<template>
    <div class="column d-flex mt-5 pt-5 align-items-center justify-content-center flex-column">
        <h1 class="font-primary success-heading mb-3 mt-5 pt-5">{{$t('ALREADY_VERIFIED')}}</h1>
        <p class="auth-explanation-text">{{$t('ALREADY_VERIFIED_EXPLANATION')}} <router-link style="text-decoration:underline" to='/login'>{{$t('LOGIN')}}</router-link>.</p>
    </div>
</template>